var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-button"},[_c('button',_vm._b({class:_vm.buttonClass,attrs:{"disabled":_vm.disabled || _vm.loading,"type":_vm.buttonType}},'button',_vm.$attrs,false),[(!_vm.loading)?_vm._t("default",function(){return [_vm._v("Submit")]}):_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":"","pulse":""}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }